import { render } from "./HeaderTextComponent.vue?vue&type=template&id=240aac78&scoped=true"
import script from "./HeaderTextComponent.vue?vue&type=script&lang=js"
export * from "./HeaderTextComponent.vue?vue&type=script&lang=js"

import "./HeaderTextComponent.vue?vue&type=style&index=0&id=240aac78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240aac78"]])

export default __exports__